<template>
  <div :class="skinType == 2 ? 'detail_box bg_gray' : 'detail_box bg_white'">
    <div class="top_nav_content">
      <div class="m-table-nav">
        <ul id="box_ul">
          <li v-for="(item, index) in gridColumns" :class="gridNavId === item.key ? 'active' : ''" :key="item.key" @click.stop="checkNav(item, index)">{{ item.name }}</li>
        </ul>
        <img :src="more_img" @click="showNav" alt="">
      </div>
      <div class="selice_box" v-show="navShow">
          <ul>
            <li v-for="(item, index) in gridColumns" :class="gridNavId === item.key ? 'active' : ''" @click.stop="checkNav(item, index)" :key="item.key">{{ item.name }}</li>
          </ul>
        </div>
    </div>
    
    <div class="loading-wrap" v-if="loading">
      <img class="loading_img" src="../assets/images/loading.png" alt="" />
    </div>
    
    <div class="empty" v-if="isEmpty">无相关信息</div>
    <div class="main" v-if="!isEmpty" @click="hide">
      <div id="chart"></div>
      <div class="list-tab" v-if="dataAll && fieldName && !isEmpty">
        <table>
          <tr>
            <th>报告日期</th>
            <th>{{fieldName ? fieldName[0].name : ''}}</th>
            <th>同比</th>
          </tr>
          <tr v-for="(item,index) in dataAll[foodType]" :key="index">
            <td>{{ item.date }}</td>
            <td>{{ checkData(item.value,fieldName[0].len,fieldName[0].unit) }}</td>
            <td :class="item.yoy | zygdColor">{{ checkData(item.yoy, 2,'%') }}</td>
          </tr>
        </table>
      </div>
    </div>
    <footer class="footer">
			<ul class="report_type">
				<li v-for="val in reportType" :key="val.type" :class="foodType === val.type ? 'active' : ''" @click="switchTab(val.type)">{{ val.name }}</li>
			</ul>
		</footer>
  </div>
</template>
<script>
import mixins from "../mixins/index";
import {  getEventData, getToken } from "../api/index.js";
export default {
  name: "Detail",
  data() {
    return {
      more_img: require("../assets/images/more_box_img.png"),
      skinType: 2,
      loading: false, //loading
      isEmpty: false, //暂无数据显示隐藏
      navShow: false, // 下拉nav显示隐藏
      weiToken: "",
      gridNavId: "", // 头部选中Id
      gridColumns: [], //头部显示的数据列表
      topNavId: "zyzb", // 当前数据类型
      foodType: "newly", //当前报告期
      dataAll:null,// 页面中所显示的数据
      echartsDom: null,
      fieldName: null,
      reportType: [
        {
          num: 0,
          type: "newly",
          name: "最新",
          report: "",
        },
        {
          num: 1,
          type: "annal",
          name: "年报",
          report: "4",
        },
        {
          num: 2,
          type: "middle",
          name: "二季度",
          report: "2",
        },
        {
          num: 3,
          type: "first",
          name: "一季度",
          report: "1",
        },
        {
          num: 4,
          type: "third",
          name: "三季度",
          report: "3",
        },
      ], //页面底部数据
      zyzb: [
        { name: "营业总收入", key: "biztotinco", type: 1, unit: "元", len: 2 },
        { name: "净利润", key: "netprofit", type: 1, unit: "元", len: 2 },
        { name: "基本每股收益", key: "basicepsn", type: 1, unit: "", len: 4 },
        { name: "稀释每股收益", key: "dilutedepsn", type: 1, unit: "", len: 4 },
        { name: "每股净资产", key: "mgjzc", type: 1, unit: "", len: 4 },
        { name: "每股现金流", key: "mgxjl", type: 1, unit: "", len: 4 },
        { name: "每股营业收入", key: "mgyyzsr", type: 1, unit: "", len: 4 },
        { name: "每股派息", key: "dividpshare", type: 1, unit: "", len: 4 },
        { name: "净资产收益率ROE", key: "roe", type: 1, unit: "%", len: 2 },
        { name: "摊薄净资产收益率", key: "jzcsyl", type: 1, unit: "%", len: 2 },
        { name: "总资产收益率ROA", key: "roa", type: 1, unit: "%", len: 2 },
        { name: "总资产回报率", key: "zzchbl", type: 1, unit: "%", len: 2 },
        { name: "销售毛利率", key: "sgpmargin", type: 1, unit: "%", len: 2 },
        { name: "销售净利率", key: "npmarginonsale", type: 1, unit: "%", len: 2 },
        { name: "税前利润率", key: "pretaxpmargin", type: 1, unit: "%", len: 2 },
        { name: "销售成本率", key: "scostrt", type: 1, unit: "%", len: 2 },
        { name: "资产负债率", key: "zcfzl", type: 1, unit: "%", len: 2 },
        { name: "权益乘数", key: "em", type: 1, len: 2, unit: "" },
        { name: "产权比率", key: "equrt", type: 1, len: 2, unit: "%" },
        { name: "流动资产/总资产", key: "casestdivtassest", type: 1, len: 2, unit: "%" },
        { name: "非流动资产/总资产", key: "ncasestdivtassest", type: 1, len: 2, unit: "%" },
        { name: "流动负债/总负债", key: "cliabdivtliab", type: 1, len: 2, unit: "%" },
        { name: "非流动负债/总负债", key: "ncliabdivtliab", type: 1, len: 2, unit: "%" },
        { name: "流动比率", key: "currentrt", type: 1, unit: "", len: 2 },
        { name: "速动比率", key: "quickrt", type: 1, unit: "", len: 2 },
        { name: "现金比率", key: "cashrt", type: 1, unit: "", len: 2 },
        { name: "经营活动产生的现金流量净额/流动负债", key: "opncashfdivcliab", type: 1, len: 2 },
        { name: "经营活动产生的现金流量/总负债", key: "opcashfdivtliab", type: 1, len: 2 },
        { name: "存货周转率(次)", key: "invturnrt", type: 1, unit: "", len: 2 },
        { name: "流动资产周转率(次)", key: "curassturnrt", type: 1, unit: "", len: 2 },
        { name: "固定资产周转率(次)", key: "faturnrt", type: 1, unit: "", len: 2 },
        { name: "总资产周转率 (次)/流动负债", key: "taturnrt", type: 1, len: 2 },
      ],
      lrb: [
        { name: "营业收入", key: "biztotinco", type: 0, unit: "元", len: 2 },
        { name: "主营收入", key: "bizinco", type: 2, unit: "元", len: 2 },
        { name: "营业成本", key: "bizcost", type: 0, unit: "元", len: 2 },
        { name: "毛利", key: "grossprofit", type: 0, unit: "元", len: 2 },
        { name: "减: 营业支出", key: "bizexpe", type: 1, unit: "元", len: 2 },
        { name: "减值损失", key: "impairmentloss", type: 1, unit: "元", len: 2 },
        { name: "营业利润", key: "perprofit", type: 0, unit: "元", len: 2 },
        { name: "非经常性项目净损益", key: "noftprobprofits", type: 1, unit: "元", len: 2 },
        { name: "加：利息收入", key: "inteinco", type: 1, unit: "元", len: 2 },
        { name: "减：利息支出", key: "inteexpe", type: 1, unit: "元", len: 2 },
        { name: "加：权益性投资损益", key: "equityinvestgal", type: 1, unit: "元", len: 2 },
        { name: "其他非经营性损益", key: "othnoperprofital", type: 1, unit: "元", len: 2 },
        { name: "税前利润", key: "totprofit", type: 0, unit: "元", len: 2 },
        { name: "所得税支出", key: "incotaxexpe", type: 1, unit: "元", len: 2 },
        { name: "加：非持续经营净利润", key: "notconopernprofit", type: 1, unit: "元", len: 2 },
        { name: "净利润", key: "netprofit", type: 0, unit: "元", len: 2 },
        { name: "归属于母公司股东的净利润", key: "netparecompprof", type: 2, unit: "元", len: 2},
        { name: "归属于少数股东的利润", key: "minysharrigh", type: 2, unit: "元", len: 2 },
        { name: "归属于非股东利润", key: "percapstockholders", type: 2, unit: "元", len: 2 },
        { name: "其他综合收益", key: "othercompinco", type: 1, unit: "元", len: 2 },
        { name: "综合全面收益", key: "compincoamt", type: 0, unit: "元", len: 2 },
        { name: "归属于母公司股东的综合收益", key: "parecompincoamt", type: 2, unit: "元", len: 2 },
        { name: "归属于少数股东的综合收益", key: "minysharincoamt", type: 2, unit: "元", len: 2 },
        { name: "基本每股收益（持续）", key: "basicepsn", type: 0, unit: "", len: 2 },
        { name: "稀释每股收益（持续）", key: "dilutedepsn", type: 0, unit: "", len: 2 },
      ],
      zcfz: [
        { name: "所有者权益 (或股东权益)合计", key: "righaggr", type: 1, unit: "元", len: 2 },
        { name: "资产总计", key: "totasset", type: 1, unit: "元", len: 2 },
        { name: "流动资产合计", key: "totalcurrliab", type: 2, unit: "元", len: 2 },
        { name: "非流动资产合计", key: "totalnoncassets", type: 2, unit: "元", len: 2 },
        { name: "非流动负债合计", key: "totalnoncliab", type: 2, unit: "元", len: 2 },
        { name: "归属于母公司股东权益合计", key: "paresharrigh", type: 1, unit: "元", len: 2 },
        { name: "流动资产合计", key: "totcurrasset", type: 1, unit: "元", len: 2 },
        { name: "现金及现金等价物", key: "curfds", type: 2, unit: "元", len: 2 },
        { name: "交易性金融资产", key: "tradfinasset", type: 2, unit: "元", len: 2 },
        { name: "应收帐款及票据", key: "notesaccorece", type: 2, unit: "元", len: 2 },
        { name: "存货", key: "inve", type: 2, unit: "元", len: 2 },
        { name: "其他流动资产", key: "othcurrasset", type: 2, unit: "元", len: 2 },
        { name: "固定资产", key: "fixedassenetw", type: 2, unit: "元", len: 2 },
        { name: "长期股权投资", key: "ltstockinvest", type: 2, unit: "元", len: 2 },
        { name: "无形资产", key: "intaasset", type: 2, unit: "元", len: 2 },
        { name: "商誉", key: "goodwill", type: 2, unit: "元", len: 2 },
        { name: "租赁土地款项及土地使用权", key: "lleapayaluser", type: 2, unit: "元", len: 2 },
        { name: "递延所得税资产", key: "defetaxasset", type: 2, unit: "元", len: 2 },
        { name: "投资性房地产", key: "investrestate", type: 2, unit: "元", len: 2 },
        { name: "其他非流动资产", key: "othernoncasse", type: 2, unit: "元", len: 2 },
        { name: "短期借贷", key: "shorttermborr", type: 2, unit: "元", len: 2 },
        { name: "贸易应付款项及应付票据", key: "notesaccopaya", type: 2, unit: "元", len: 2 },
        { name: "交易性金融负债", key: "tradfinliab", type: 2, unit: "元", len: 2 },
        { name: "应付股利", key: "dividrece", type: 2, unit: "元", len: 2 },
        { name: "应付税项", key: "taxpayable", type: 2, unit: "元", len: 2 },
        { name: "其他流动负债", key: "othalcurrliab", type: 2, unit: "元", len: 2 },
        { name: "长期借贷", key: "longborr", type: 2, unit: "元", len: 2 },
        { name: "其它非流动负债", key: "othalnoncliab", type: 2, unit: "元", len: 2 },
        { name: "负债总计", key: "totliab", type: 1, unit: "元", len: 2 },
        { name: "优先股", key: "preferredstock", type: 2, unit: "元", len: 2 },
        { name: "库存股", key: "treasurystock", type: 2, unit: "元", len: 2 },
        { name: "股本", key: "capitalstock", type: 2, unit: "元", len: 2 },
        { name: "储备", key: "reserve", type: 2, unit: "元", len: 2 },
        { name: "未分配利润", key: "undiprof", type: 2, unit: "元", len: 2 },
        { name: "少数股东权益", key: "minysharrigh", type: 2, unit: "元", len: 2 },
        { name: "股东权益及负债总额", key: "totliabsharequi", type: 1, unit: "元", len: 2 },
      ],
      xjll: [
        { name: "现金及现金等价物净增加额", key: "cashnetr", type: 1, unit: "元", len: 2 },
        { name: "经营活动产生的现金流净额", key: "mananetr", type: 1, unit: "元", len: 2 },
        { name: "投资活动产生的现金流净额", key: "invnetcashflow", type: 1, unit: "元", len: 2 },
        { name: "筹资活动产生的现金流净额", key: "finnetcflow", type: 1, unit: "元", len: 2 },
        { name: "现金及现金等价物的年末余额", key: "fincashbala", type: 1, unit: "元", len: 2 },
        { name: "税前利润", key: "btaxprofit", type: 2, unit: "元", len: 2 },
        { name: "折旧与摊销", key: "deprecamortiza", type: 2, unit: "元", len: 2 },
        { name: "营运资本变动", key: "wcapitalchg", type: 2, unit: "元", len: 2 },
        { name: "已缴税款", key: "paidtax", type: 2, unit: "元", len: 2 },
        { name: "其他非现金调整", key: "othncashitemsad", type: 2, unit: "元", len: 2 },
        { name: "投资活动现金流入小计", key: "invcashinfl", type: 1, unit: "元", len: 2 },
        { name: "处置固定资产、无形资产和其他长期资产所收回的现金", key: "fixedassetnetc", type: 2, unit: "元", len: 2 },
        { name: "出售金融资产产生的现金流入", key: "salefinasstflow", type: 2, unit: "元", len: 2 },
        { name: "股权投资产生的现金流入", key: "equitycashflow", type: 2, unit: "元", len: 2 },
        { name: "股利利息收入", key: "divinterestinc", type: 2, unit: "元", len: 2 },
        { name: "借出借款收回产生的现金流入", key: "llrecgencashif", type: 2, unit: "元", len: 2 },
        { name: "关联方归还借款", key: "relpartyloan", type: 2, unit: "元", len: 2 },
        { name: "其他与投资活动有关的现金流入", key: "othinvcashflow", type: 2, unit: "元", len: 2 },
        { name: "投资活动现金流出小计", key: "invcashoutf", type: 1, unit: "元", len: 2 },
        { name: "资本支出", key: "capitalspending", type: 2, unit: "元", len: 2 },
        { name: "购入金融资产产生的现金流出", key: "bfinassetsc", type: 2, unit: "元", len: 2 },
        { name: "股权投资产生的现金流出", key: "equityinvestc", type: 2, unit: "元", len: 2 },
        { name: "借出借款产生的现金流出", key: "lbcashoutflow", type: 2, unit: "元", len: 2 },
        { name: "借予关联方款项", key: "lrelaparties", type: 2, unit: "元", len: 2 },
        { name: "其他与投资活动有关的现金流出", key: "othequityint", type: 2, unit: "元", len: 2 },
        { name: "筹资活动现金流入小计", key: "fincashinfl", type: 1, unit: "元", len: 2 },
        { name: "权益增加", key: "equitybuildup", type: 2, unit: "元", len: 2 },
        { name: "债务增加", key: "debtsbigger", type: 2, unit: "元", len: 2 },
        { name: "其他筹资活动产生的现金流入", key: "othfincashinfl", type: 2, unit: "元", len: 2 },
        { name: "筹资活动现金流出小计", key: "fincashoutf", type: 1, unit: "元", len: 2 },
        { name: "权益减少", key: "equitydecreases", type: 2, unit: "元", len: 2 },
        { name: "债务减少", key: "debtsdecreases", type: 2, unit: "元", len: 2 },
        { name: "支付股利、利息产生的现金流出", key: "paydivintcof", type: 2, unit: "元", len: 2 },
        { name: "其他筹资活动产生的现金流出", key: "othfincflow", type: 2, unit: "元", len: 2 },
        { name: "四、汇率变动对现金及现金等价物的影响", key: "chgexchgchgs", type: 1, unit: "元", len: 2 },
        { name: "加：现金及现金等价物的年初余额", key: "inicashbala", type: 2, unit: "元", len: 2 },
      ],
      showKeys: [],
      code: "",
    };
  },
  mixins: [mixins],
  created() {
    if (this.getUrlQuery("themeStyleVs") == 2) {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#0d1018;color: #637693;");
    } else {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#f1f1f1;color: #666;");
    }
    this.skinType = this.getUrlQuery("themeStyleVs");
    this.code = this.getUrlQuery("code");
    this.topNavId = this.getUrlQuery("type");
  },
  mounted() {
    let that = this;
    that.gridColumns = that[that.topNavId];
    that.gridNavId = that.getUrlQuery("key");
    that.getWeiToken();
    that.$nextTick(function(){
      that.loadCheckNav();
    })
  },
  watch: {},
  methods: {
    loadCheckNav:function(){
      let that = this;
      let index = 0;
      let navArr = that.gridColumns;
      navArr.forEach((item,itemIndex)=>{
        if(item.key === that.gridNavId){
          index = itemIndex
        }
      })
      let doc = document;
      let WINDOW_OFFSETWIDTH = doc.getElementsByClassName("m-table-nav")[0].offsetWidth;
      let liArr = doc.querySelectorAll("#box_ul > li");
      let itemWidth = liArr[index].offsetWidth;
      let moveX = liArr[index].offsetLeft;
      let left = moveX - WINDOW_OFFSETWIDTH / 2 + itemWidth / 2;
      doc.getElementById("box_ul").scrollLeft = left;
    },
    checkNav:function(item, index){
      let that = this;
      that.gridNavId = item.key;
      let doc = document;
      let WINDOW_OFFSETWIDTH = doc.getElementsByClassName("m-table-nav")[0].offsetWidth;
      let liArr = doc.querySelectorAll("#box_ul > li");
      let itemWidth = liArr[index].offsetWidth;
      let moveX = liArr[index].offsetLeft;
      let left = moveX - WINDOW_OFFSETWIDTH / 2 + itemWidth / 2;
      doc.getElementById("box_ul").scrollLeft = left;
      that.navShow = false;
      that.$nextTick(function(){
        that.getQueryData();
      })
    },
    showNav: function(){
      let that = this;
      that.navShow = !that.navShow
    },
    hide:function(){
      this.navShow = false;
    },
    // 获取token
    getWeiToken: function () {
      let that = this;
      let obj = {
        merId: window.config.merId,
        busiCode: window.config.busiCode,
        sign: window.config.sign,
      };
      getToken(JSON.stringify(obj)).then((res) => {
        if (res.resCode === "000000") {
          that.weiToken = res.resData.token;
          that.$nextTick(function(){
            that.getQueryData();
          })
        }
      }).catch(err=>{
        console.log(err);
        that.loading = false;
        that.isEmpty = true;
      });
    },
    // 获取页面数据
    getQueryData:function(){
      let that = this;
      that.loading = true;
      let obj = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: "mapdata/" + that.topNavId + '/' + that.code + "/" + that.gridNavId,
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(obj), that.weiToken).then(res=>{
        that.loading = false;
        if(res.resCode === "000000" && res.resData[obj.reqData.busiType]){
          that.dataAll = res.resData[obj.reqData.busiType];
          that.fieldName = that[that.topNavId].filter(item=>{
              return item.key === that.gridNavId;
            });
          that.$nextTick(function(){
            if(that.dataAll[that.foodType].length > 0){
              that.isEmpty = false;
              that.chart();
            }else{
              that.isEmpty = true;
            }
          })
        }else{
          that.isEmpty = true;
        }
      }).catch(function(){
        that.loading = false;
        that.isEmpty = true;
      })
    },
    // echartsDom
    chart:function () {
      let that = this;
      let data = that.dataAll && that.dataAll[that.foodType] ? that.dataAll[that.foodType].reverse() : [];
      let timeData = data.map(item=>{
        return item.bglx;
      })
      let valueData = data.map(item=>{
        return item.value;
      })
      if (!that.echartsDom) {
        that.echartsDom = that.$echarts.init(document.getElementById('chart'));
        window.addEventListener("resize", that.resizeHandler);
      }
      let startNum = 80;
      if (valueData.length <= 6) {
        startNum = 0;
      } else if (valueData.length < 30) {
        startNum = (1 - 6 / valueData.length) * 100;
      }
      let fieldName = that.fieldName;
      let dataZoom = [
        {
          type: 'slider',
          show: true,
          realtime: true,
          borderColor: '#eee',
          // height:20,
          bottom: 10,
          dataBackground: {
            lineStyle: {
              width: 0
            }
          },
          start: Math.ceil(startNum + 1),
          end: 100,
          handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleStyle: {
            color: '#fff',
            shadowBlur: 3,
            shadowColor: 'rgba(0, 0, 0, 0.6)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
        }
      ];
      // 显示标题，图例和空的坐标轴
      this.echartsDom.setOption({
        grid: {
          top: 20,
          bottom: 80,
          left: 20,
          right: 20
        },
        tooltip: {
          trigger: 'axis',
          formatter (params) {
            return params[0].name + '<br/>' + fieldName[0].name + ' : ' + that.checkData(params[0].value,2,fieldName[0].unit);
          },
          axisPointer: {
            animation: false
          },
          extraCssText:"z-index:5;"
        },
        legend: {
          show: false
        },
        dataZoom,
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: timeData,
          splitNumber: 3,
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: that.skinType != 2 ? '#e5e5e5' : '#28303b'
            }
          },
          axisLabel: {
            showMaxLabel: true,
            color: that.skinType != 2 ? '#666' : "#d5dce5",
            formatter: value => `${value.substring(0, 5)}\n${value.substring(5)}`
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: that.skinType != 2 ? '#e5e5e5' : "#28303b",
              type: "solid"
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            inside: true,
            color: that.skinType != 2 ? '#666' : "#d5dce5",
            formatter:function(value){
              return that.checkData(value,0,fieldName[0].unit);
            }
          },
          axisLine: {
            lineStyle: {
              color: that.skinType != 2 ? '#e5e5e5' : '#28303b'
            }
          },
          axisTick: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: that.skinType != 2 ? '#e5e5e5' : "#28303b",
              type: "dotted"
            }
          }
        },
        series: [
          {
            type: 'line',
            symbolSize: 7,
            symbol: 'circle',
            itemStyle: {
              color: 'rgba(0, 0, 0, 0)',
              borderColor: '#5793f1'
            },
            areaStyle: {
              color: 'rgba(0, 0, 0, 0)'
            },
            lineStyle: {
              width: 2,
                color: '#0054d5'
            },
            connectNulls: true,
            data: valueData
          }
        ]
      });
    },
    resizeHandler:function(){
      this.echartsDom.resize();
    },
      // 处理页面中数据（小数点以及数据单位）
    checkData: function (num,len,util) {
			if(util === '元'){
				return this.process(num,len);
			}else if(util === '%'){
				return this.gainsCheck(num,len,util);
			}else if(util === 'not'){
				return;
			} else{
				return this.gainsCheck(num,len,'');
			}
		},
    switchTab:function(type){
      let that = this;
      that.foodType = type;
      if(that.dataAll[type].length > 0){
        that.isEmpty = false;
        that.$nextTick(function(){
        that.chart();
        })
      }else{
        that.isEmpty = true;
        if(that.echartsDom){
          that.echartsDom.dispose();
          that.echartsDom = null;
        }
      }
      
    }
  },
};
</script>
<style lang="less">
@import "../assets/css/cwts_details.css";
</style>